/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { WINDOW } from '../utils'

type NewRelicBrowserWindow = Window & {
  newrelic?: {
    addPageAction: (name: string, attributes: Record<string, unknown>) => void
    noticeError: (error: Error | HttpErrorResponse, attributes?: Record<string, unknown>) => void
  }
}

export enum PageAction {
  APP_LOADED = 'Signup-AppLoaded',
}

@Injectable({
  providedIn: 'root',
})
export class NewRelicService {
  private readonly window = inject<NewRelicBrowserWindow>(WINDOW)

  addPageAction(country: string): void {
    if (this.window['newrelic']) {
      this.window['newrelic'].addPageAction(PageAction.APP_LOADED, {
        timestamp: new Date().toISOString(),
        appCountry: country,
      })
    }
  }

  noticeError(error: Error | HttpErrorResponse, traceId?: string): void {
    if (this.window['newrelic']) {
      if (error instanceof HttpErrorResponse) {
        this.window['newrelic'].noticeError(error, {
          'x-trace-id': traceId,
        })
      } else {
        this.window['newrelic'].noticeError(error)
      }
    }
  }
}
